import { useEffect } from "react";
import { UserImage } from "@circle-react-uikit/UserImage";
import { useFormContext, useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { useCommunityMemberSearch } from "@/react/hooks/useCommunityMemberSearch";
import { Select } from "@circle-react-uikit/Select";
import { Typography } from "@circle-react-uikit/Typography";

interface CommunityMember {
  avatar_url: string;
  id: number;
  name: string;
}

interface FormValues {
  ai_paused_notification_recipient_ids: number[];
}

export const AdminSelect = () => {
  const { searchCommunityMembers, communityMembers } =
    useCommunityMemberSearch();
  const { setValue } = useFormContext<FormValues>();
  const rawSelectedIds = useWatch<FormValues>({
    name: "ai_paused_notification_recipient_ids",
  });
  const selectedIds = Array.isArray(rawSelectedIds)
    ? rawSelectedIds.map(String)
    : [];

  const data = (communityMembers as CommunityMember[]).map(member => ({
    text: member.name,
    value: String(member.id),
    listItemText: (
      <div className="flex items-start px-2">
        <UserImage
          src={member.avatar_url}
          name={member.name}
          size="5"
          isFullRounded
        />

        <div className="ml-3 flex min-w-0 flex-col">
          <Typography.LabelSm weight="medium">{member.name}</Typography.LabelSm>
        </div>
      </div>
    ),
  }));

  const searchAdmins = (query: string) =>
    searchCommunityMembers({
      query,
      filters: {
        role: "Admin",
      },
      per_page: 100,
    });

  useEffect(() => {
    void searchAdmins("");
  }, []);

  const handleChange = ({ value }: { value: string[] }) => {
    setValue("ai_paused_notification_recipient_ids", value.map(Number));
  };

  return (
    <Select
      name="ai_paused_notification_recipient_ids"
      placeholder={t(
        "community_bot.bot_builder.behavior_page.pause_ai_setting.select_admins",
      )}
      onSearch={searchAdmins}
      onChange={handleChange}
      data={data}
      direction="up"
      variant="tags"
      value={selectedIds}
      showSearchIcon={false}
      shouldFilterSelectedItems
      hideIcon
    />
  );
};
